import { Ease24, Tween24 } from 'tween24'
import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import common from './modules/common'
import './search.scss'

const elementIntersecting = document.querySelectorAll('.shop')
const intersectOptions = {
  rootMargin: "-20% 0px",
  threshold: 0,
}
const observer = new IntersectionObserver(showContent, intersectOptions)

const naviButton = document.querySelectorAll('.navi a')
const pagetop = document.querySelectorAll('.pagetop a')

const easeOutCubic = (x) => {return 1 - Math.pow(1 - x, 3)}
const duration = 700
let startTime
let startScrollY
let pos
let diff

window.addEventListener('load', () => {
  common()
  elementIntersecting.forEach(box => {
    observer.observe(box)
  })

  pagetop.forEach((el, index) => {
    el.addEventListener('click', (event) => {
      event.preventDefault()
      dist(99)
    })
  })

  // ナビゲーションメニュー
  naviButton.forEach((el, index) => {
    el.addEventListener('click', (event) => {
      let pageid = el.dataset.pid
      event.preventDefault()
      dist(pageid)
    })
  })

})

// lazyload
function showContent (entries) {
  entries.forEach( entry => {
    if(entry.isIntersecting) {
      if(!entry.target.classList.contains('shown')) {
        entry.target.classList.add('shown')
        Tween24.serial(
          Tween24.prop(entry.target).y(100),
          Tween24.tween(entry.target, .4, Ease24._2_QuadOut).opacity(1).y(0)
        ).play()  
      }
    }
  })
}

// スクロールアニメーション
function scrolling () {
  const progress = Math.min(1, (Date.now() - startTime) / duration)
  const scrollY = (startScrollY + diff * easeOutCubic(progress))
  window.scrollTo(0, scrollY)
  if(progress < 1) {
    requestAnimationFrame(scrolling)
  }
}

// スクロールする距離を決める
function dist(id) {
  let offset
  startTime = Date.now()
  startScrollY = window.scrollY + 1
  
  if(document.location.hash) document.location.hash = ''

  if(id === 99 || id === "top") {
    pos = 0
  } else {
    offset = 50
    pos = window.scrollY + document.getElementById(id).getBoundingClientRect().top - offset
  }
  diff = (startScrollY - pos) * -1
  scrolling()
}
